$(document).ready(() => {

  $('#burger-menu').click(function(){
    $('#overlay-nav-mobile').fadeIn();
    $('#nav-mobile').css({'left':'0px'});
    $('body').addClass('fixed');
  })
  $('#overlay-nav-mobile').click(function(){
    $(this).fadeOut();
    $('#nav-mobile').css({'left':'-100%'});
    $('body').removeClass('fixed');
  })

});


// WEBPACK FOOTER //
// ./js/menumobile.js